import { TextField } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import React, { memo, useEffect, useState } from "react";

const textFieldStyle = {
  width: '90%'
}
/**
 * This TextFieldElement should be used for Material.jsx and memoizes a TextField with its own inner state.
 * This prevents unwanted rerendering.
 */
const TextFieldElement = memo(({ properties, name, initialValue, updateData, isStatic, triggerDataChange }) => {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue, triggerDataChange]);

  return (
    <TextField
      required={name === 'name' ? true : false}
      variant="outlined"
      size="small"
      name={name}
      sx={textFieldStyle}
      label={properties.label}
      type={properties.type}
      InputProps={{ inputProps: properties.inputProps, endAdornment: properties.endAdornment }}
      InputLabelProps={{ shrink: true }}
      value={value === null ? "" : value}
      onChange={(event) => {
        setValue(event.target.value);
        updateData(event);
      }}
      select={properties.select ? true : false}
      disabled={isStatic}
    >
      {properties.children?.map((x, i) => (
        <MenuItem key={i} value={x.value}>
          {x.name}
        </MenuItem>
      ))}
    </TextField>
  );
});

export default TextFieldElement;